// Prefix auth/2FA Mixpanel events with the app name (matches the Trust console's
// "Trust Console - <event>" convention) so identically-named events (2FA Shown /
// Verified / ...) don't get mixed up in the shared Mixpanel project.
export const TWOFA_EVENT_PREFIX = 'Search Console - ';

export default { MODULE_NAME: 'login' };
